import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/device'

function* fetchDevicesRefresh() {
  let fe = JSON.parse(localStorage.getItem('fetchDevices'))
  if (fe == null) {
    fe = {}
    fe.size = localStorage.getItem('pageSize') || 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  } else {
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_DEVICE,
    result,
  })
}

function* fetchDevices({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = null // JSON.parse(localStorage.getItem('fetchDevices'))
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = size || localStorage.getItem('pageSize') || 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchDevices', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_DEVICE,
    result,
  })
}

function* fetchDeviceEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_DEVICE,
    result,
  })
}

function* fetchDeviceSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_DEVICE_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_DEVICES,
  })
}

function* fetchDeviceDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_DEVICE_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_DEVICES,
  })
}

function* filterDevices() {
  const result = yield call(list, 10000000, 0, '%20', '%20')
  yield put({
    type: actions.FILTER_DEVICES_RECIEVED,
    result,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_DEVICES, fetchDevices),
    takeEvery(actions.FETCH_DEVICE, fetchDeviceEdit),
    takeEvery(actions.SAVE_DEVICE, fetchDeviceSave),
    takeEvery(actions.DELETE_DEVICE, fetchDeviceDelete),
    takeEvery(actions.RE_FETCH_DEVICES, fetchDevicesRefresh),
    takeEvery(actions.FILTER_DEVICES, filterDevices),
  ])
}
